import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SortIcon from "@material-ui/icons/Sort";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import { CommonCss } from "../../services/CommonCss";
import Radio from "@material-ui/core/Radio";
import Moment from "react-moment";
import MUIDataTable from "mui-datatables";
import { ThemeProvider } from "@mui/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { getDataGridUtilityClass } from "@mui/x-data-grid";
import { InsertEmoticon } from "@mui/icons-material";
import { isExists } from "date-fns";
import { getCookie } from "../../services/Cookies";
//const customerContractData = require("../../../data/customerContractDetails.json");
//const contractData = [];
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },


}))(TableCell);

const useStyles = makeStyles((theme) => ({
  headBox: {
    background: "#1A1A31 0% 0% no-repeat padding-box",
    borderRadius: "10px 10px 0px 0px",
  },
  mainBox: {
    boxShadow: "3px 3px 6px #00000029",
    borderRadius: " 0px 0px 10px 10px",
  },
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 25
    }
  },
  text1: {
    fontSize: "17px",
    letterSpacing: "0.54px",
    fontWeight: 400,
    color: "#1A1A31",
  },
  text2: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#5A5B5E",
  },
  text3: {
    fontSize: "21px",
    fontWeight: 600,
    color: "#fff",
    letterSpacing: "0.63px",
  },
  link: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "17px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
      color: "#ff4717"
    }
 
  },
  rowHeaderBox: {
    "& div": {
      borderRight: "1px solid #707070",
      paddingRight: "8px",
    },
  },
  rowBox: {
    borderBottom: "1px solid #00000029",
    boxShadow: "0 1px 0px 0px #00000029",
  },
  hoverBox: {
    boxShadow: "3px 3px 6px #00000029",
    borderRadius: "10px",
  },
  sortBy: {
    right: "66px",
  },
  downloadBy: {
    right: "0px",
  },
  radioButton: {
    padding: "0px",
    paddingRight: "4px",
    "& svg": {
      fontSize: "1rem",
    },
  },
  radio: {
    "&$checked": {
      color: "#4B8DF8",
    },
  },
}));
function Equipment(props) {
  const classes = useStyles();
  const commonClasses = CommonCss();
  const [sortBy, setSortBy] = useState(false);
  const [downloadBy, setDownloadBy] = useState(false);
  const { rows, dataOfEquipement, onHandleSubmit } = props;
  const [shipRow,setShipRow]=useState([]);

  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      }
    }
  })

  const columns = [
    {
      name: "usage",
      label: "Usage",
      options: {
        filter: true,
        sort: true,
      }

    },
    {
      name: "type",
      label: "Type",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "make",
      label: "Make",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "model",
      label: "Model",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "lubeBrand",
      label: "Lube Brand",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "lubeGrade",
      label: "Lube Grade",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "systemOilVolume",
      label: "System Oil",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "template",
      label: "Template",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "lastSamplingDate",
      label: "Last Sampling Date",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "frequency",
      label: "Sampling Frequency",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "nextSamplingDate",
      label: "Next Sampling Date",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "actions",
      label: "Sampling Frequency Edit",
      options: {
        filter: false,
        sort: true,
        download:false,
        display: (getCookie("userRole") == "VPS Admin" ? true : "excluded"),
        customBodyRender: (Value, tableMeta) => {
         // return <button className={classes.link} onClick={() => { onHandleSubmit(tableMeta) }}>Edit</button>
       
          return <button className={classes.link} onClick={() => { onHandleSubmit(tableMeta.currentTableData[tableMeta.rowIndex]) }}>Edit</button>
       }
        }
      }
   
  ]

  const options = {
    customToolbarSelect:()=>{
      <>
      onRowsDelete:True,
      </>
      
    },
    selectToolbarPlacement:"above",
    selectableRows:"multiple",
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    downloadOptions: {
      
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    },


  onRowSelectionChange:(currentRowsSelected,allRowsSelected,rowsSelected)=>{
   
    let isExist=[];
    rowsSelected.forEach((d)=>{
    isExist.push(dataOfEquipement[d]);
    console.log("isExist",isExist)
  })

setShipRow(isExist)
},

  onDownload:(buildHead, buildBody,columns, gridData)=>{
    
    var myData= [];
    var newKeys = Object.keys( dataOfEquipement[0]);
    var idx = 0;
    var columnsExport = [];
    var columnsExport1 = [];
    columnsExport.push("");
    var columnshead=columns.splice(0,12)
    console.log("cols",columnshead)
    columnshead.forEach((cl) => {
      //if(cl.label!=="Customer Contract")
      columnsExport.push(cl.label);

    })
    // newKeys.forEach((k) => {
    //   columnsExport.push(k);
    // });
    columnsExport.push("\n");
   let i = 0;
   
    //console.log(item);
    shipRow.length>0?
    (
      shipRow.forEach((item) => {
    let visibleRows = gridData.filter((df) => {
      let dfdt = df.data;
      if (dfdt[0] == item.usage && dfdt[1] == item.type)
        return true;
      else
        return false;

    });
   if (visibleRows.length > 0) {
    
    let itemData = { ...item };
    let dataItem = []
    if (i == 0)
      dataItem.push("");
    i++;
   let objsample={
    uasge:itemData.usage,
    type:itemData.type,
    description:itemData.description,
    make:itemData.make,
    model:itemData.model,
    lubebrand : itemData.lubeBrand,
    lubeGrade: itemData.lubeGrade,
     systemoil: itemData.systemOilVolume,
     template:itemData.template,
     lastSamplingDate:itemData.lastSamplingDate,
     frequency:itemData.frequency,
     nextSamplingDate:itemData.nextSamplingDate
   }
   
      let data = [];
      data.push(...Object.values({ ...objsample}));
      data.push("\n");
      dataItem.push(data);
    // });
    myData.push(...dataItem);
    // console.log("myData",myData)
   }
})
    ):(
    
      dataOfEquipement.forEach((item) => {
        debugger
      let visibleRows = gridData.filter((df) => {
        let dfdt = df.data;
        if (dfdt[0] == item.usage && dfdt[1] == item.type)
          return true;
        else
          return false;
  
      });
     if (visibleRows.length > 0) {
      
      let itemData = { ...item };
      let dataItem = []
      if (i == 0)
        dataItem.push("");
      i++;
     let objsample={
      uasge:itemData.usage,
      type:itemData.type,
      description:itemData.description,
      make:itemData.make,
      model:itemData.model,
      lubebrand : itemData.lubeBrand,
      lubeGrade: itemData.lubeGrade,
       systemoil: itemData.systemOilVolume,
       template:itemData.template,
       lastSamplingDate:itemData.lastSamplingDate,
       frequency:itemData.frequency,
       nextSamplingDate:itemData.nextSamplingDate
     }
     
        let data = [];
        data.push(...Object.values({ ...objsample}));
        data.push("\n");
        dataItem.push(data);
      // });
      myData.push(...dataItem);
      // console.log("myData",myData)
     }
    })
    )
buildHead = () => {
console.log(columnsExport);
return columnsExport;
}
buildBody = () => {
// console.log(myData);
return  myData;
}
return buildHead() + buildBody();
  }
}
  
  return (
    <div>
      <Box bgcolor="#fff" className={clsx(classes.mainBox)}>
        <Box
          background="#1A1A31"
          position="relative"
          px={4}
          py={1}
          color="#fff"
          className={clsx(classes.headBox)}
        >
          <Box
            display="flex"
            className={clsx(classes.text3, commonClasses.justifyContentBetween)}
          >
            <Box>Equipment</Box>
            <Box>
              <Box className="hidediv" component="span" pr={2}>
                <SortIcon
                  className={commonClasses.cursorPointer}
                  onClick={() => {
                    setDownloadBy(false);
                    setSortBy(!sortBy);
                  }}
                />
                <Box
                  position="absolute"
                  className={clsx(classes.hoverBox, classes.sortBy)}
                  zIndex={3}
                  bgcolor="#fff"
                  display={sortBy ? "block" : "none"}
                  top={52}
                  width={0.08}
                  px={2}
                  pb={4}
                >
                  <Box component="h6" my={1} color="#FF4717" fontSize="15px">
                    Sort By:
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="Sequence"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>Sequence</Box>
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="Group"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>Group</Box>
                  </Box>
                </Box>
              </Box>
              <Box  className="hidediv" component="span">
                <GetAppIcon
                  className={commonClasses.cursorPointer}
                  onClick={() => {
                    setSortBy(false);
                    setDownloadBy(!downloadBy);
                  }}
                />
                <Box
                  position="absolute"
                  className={clsx(classes.hoverBox, classes.downloadBy)}
                  zIndex={3}
                  bgcolor="#fff"
                  display={downloadBy ? "block" : "none"}
                  top={52}
                  width={0.08}
                  px={2}
                  pb={4}
                >
                  <Box component="h6" my={1} color="#FF4717" fontSize="15px">
                    Download:
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="PDF"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>PDF</Box>
                  </Box>
                  <Box
                    component="p"
                    m={0}
                    pb={1}
                    color="#5A5B5E"
                    fontSize="12px"
                    display="flex"
                    alignItems="center"
                  >
                    <Radio
                      value="MSExcel"
                      name="radio-button-sort"
                      className={clsx(classes.radioButton)}
                      py={1}
                    />
                    <Box>MS Excel</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box px={2} pt={3} pb={3} className="reportstablehead">


          <ThemeProvider theme={getMuiTheme()}>
            {dataOfEquipement.length
              ? <MUIDataTable
                data={dataOfEquipement}
                className={classes.tableBody}
                columns={columns}
                options={options}
              /> : <MUIDataTable
                className={classes.tableBody}
                columns={columns}
                options={options}
              />}
            

          </ThemeProvider>


        </Box>

        {/* <Box className={classes.root}>
            <TableContainer
              component={Paper}
              className={clsx(classes.TableTheme)}
            >
              <Table
                aria-label="collapsible table"
                className={classes.tableLayout}
              >
                <TableHead>
                  <TableRow>  */}
        {/* <StyledTableCell className="bl-bg">
                  VPS ID	
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Cust ID
                    </StyledTableCell> */}
        {/* <StyledTableCell className="bl-bg">
                   Usage
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Type
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Description
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Make
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Model
                    </StyledTableCell> */}
        {/* <StyledTableCell className="bl-bg">
                    Location
                    </StyledTableCell>*/}

        {/* <StyledTableCell className="bl-bg">
                    Lube Brand
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Lube Grade
                    </StyledTableCell>                     <StyledTableCell className="bl-bg">
                    System Oil
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Template
                    </StyledTableCell> */}
        {/* <StyledTableCell className="bl-bg">
                    Info
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Test Limit
                    </StyledTableCell> */}
        {/* <StyledTableCell className="bl-bg">
                    Last Sampling Date 
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Sampling Frequency
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Next Sampling Date
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                    Sampling Frequency Edit
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  
          {dataOfEquipement.length
            ? dataOfEquipement.map((row) => (

                <TableRow> */}

        {/* <StyledTableCell  >
                    <Box>{row.vpsId}</Box> 
                    </StyledTableCell>
                    <StyledTableCell  >
                    <Box>{row.custId}</Box> 
                    </StyledTableCell> */}
        {/* <StyledTableCell >
                    <Box>{row.usage}</Box> 
                    </StyledTableCell>  
                    <StyledTableCell >
                    <Box>{row.type}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.description}</Box> 
                    </StyledTableCell>
                     <StyledTableCell >
                    <Box>{row.make}</Box>
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.model}</Box>
                    </StyledTableCell> */}
        {/*  <StyledTableCell >
                   <Box>{row.Location}</Box> 
                    </StyledTableCell>*/}
        {/* <StyledTableCell >
                    <Box>{row.lubeBrand}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.lubeGrade}</Box> 
                    </StyledTableCell> 
                    <StyledTableCell >
                    <Box>{row.systemOilVolume}</Box>
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.template}</Box>
                    </StyledTableCell> */}
        {/* <StyledTableCell >
                    <Box>{row.Info}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box>{row.TestLimit}</Box> 
                    </StyledTableCell> */}
        {/* <StyledTableCell >
                    <Box>{row.lastSamplingDate ?(<Moment format="DD/MM/YYYY">{row.lastSamplingDate}</Moment>):""}</Box> 
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.frequency==0?"Ad hoc":row.frequency}</Box>
                    </StyledTableCell>
                    <StyledTableCell >
                    <Box> {row.nextSamplingDate ?(<Moment format="DD/MM/YYYY">{row.nextSamplingDate}</Moment>):""}</Box>
                    </StyledTableCell>
                     <StyledTableCell >
                    <Box  className={classes.link} onClick={() => { onHandleSubmit(row) }}>    {"Edit"}</Box>
                    </StyledTableCell> 
                    
                    
                  </TableRow>
                )):(
                  <TableRow>
                    <TableCell>
                      No Data
                    </TableCell>
                  </TableRow>
                )}
                
                </TableBody>
              </Table>
            </TableContainer>
          </Box> */}



        {/*  <Box
            display="flex"
            py={2}
            px={2}
            className={clsx(
              commonClasses.justifyContentBetween,
              classes.text2,
              classes.rowHeaderBox,
              classes.rowBox
            )}
          >
           
          
           <Box>VPS Id</Box>
            <Box>Cust Id</Box>
            <Box>Usage</Box>
            <Box>Type</Box>
            <Box>Description</Box>
            <Box>Make</Box>
            <Box>Model</Box>
            <Box>Location</Box>
            <Box>Lube Brand</Box>
            <Box>Lube Grade</Box>
            <Box>System Oil </Box>
            <Box>Template </Box>
            <Box>Info </Box>
            <Box>Test Limit </Box>
            <Box>Last </Box>
            <Box>Frequence </Box>
            <Box>Next Sampling Date </Box>
           <Box borderRight="0px solid #000 !important">Modified By </Box>
         
         
  
         
         
         
           <Table >
           <thead>
             <tr>
               <th>VPS ID</th>
               <th>Cust ID</th>
               <th>Type</th>
               <th>Description</th>
               <th>Make</th>
               <th>Model</th>
               <th>Location</th>
               <th>Lube Brand</th>
               <th>Lube Grade</th>
               <th>System Oil</th>
               <th>Template</th>
               <th>Info</th>
               <th>Test Limit</th>
               <th>Last </th>
               <th>Frequence</th>
               <th>Next Sampling Date</th>
               <th>Modified By</th>

              
             </tr>
           </thead>
          

           </Table>
          </Box>*/}

        {/* <Box px={4} py={2} className={clsx(classes.text1, classes.rowBox)}>
            <Box display="flex" alignItems="center">
              <Box component="span" pr={2} color="#FF4717">
                <AddCircleOutlineIcon />
              </Box>
              <Box component="span" color="#FF4717">
                CLICK TO ADD NEW ITEM
              </Box>
            </Box>
          </Box> */}

        {/* <Paper className={classes.paper + " scrollBar"}
            style={{ height: "420px", overflow: "auto" }}>
<listStyled component="nav" className="scroll-list">
          {dataOfEquipement.length
            ? dataOfEquipement.map((row) => (

                <Box
                  display="flex"
                  py={2}
                  px={2}
                  className={clsx(
                    classes.text1,
                    commonClasses.justifyContentBetween,
                    classes.rowBox
                  )}
                 
                >
                  <Box>{row.vpsId}</Box>
                  <Box>{row.custId}</Box>
                  <Box>{row.usage}</Box>
                  <Box>{row.type}</Box>
                  <Box>{row.description}</Box>
                  <Box>{row.make}</Box>
                  <Box>{row.model}</Box>
                  <Box>{row.Location}</Box>
                  <Box>{row.lubeBrand}</Box>
                  <Box>{row.lubeGrade}</Box>
                  <Box>{row.systemOilVolume}</Box>
                  <Box>{row.template}</Box>
                  <Box>{row.Info}</Box>
                  <Box>{row.TestLimit}</Box>
                  <Box>{row.lastSamplingDate ?(<Moment format="DD/MM">{row.lastSamplingDate}</Moment>):""}</Box>
                  <Box>{row.frequency  ?(<Moment format="DD/MM">{row.frequency}</Moment>):""}</Box>
                  <Box>{row.NextSamplingDate ?(<Moment format="DD/MM">{row.NextSamplingDate}</Moment>):""}</Box>
                  <Box>{row.ModifiedBy }</Box>
                  
                </Box>
                
            
              ))
            : "No records found"}
            </listStyled>
            </Paper> */}

      </Box>
    </div>
  );
}

Equipment.propTypes = {};

export default Equipment;
